import type { Database } from 'sql.js';
import type { OfflineUploadPersistBatch } from '../../domain/offlineUploadPersist.ts';

function rollbackQuiet(db: Database): void {
  try {
    db.run('ROLLBACK');
  } catch {
    /* ignore */
  }
}

function placeholders(n: number): string {
  return Array.from({ length: n }, () => '?').join(', ');
}

/**
 * Marks delivery-point and redemption headers as uploaded in one transaction (same logical sync batch).
 */
export function markOfflineUploadCompleteInDb(
  db: Database,
  notifyPersist: () => void,
  batch: OfflineUploadPersistBatch,
): void {
  const { puntoIds, redencionIds, uploadedAtIso } = batch;
  if (puntoIds.length === 0 && redencionIds.length === 0) return;

  db.run('BEGIN IMMEDIATE');
  try {
    if (puntoIds.length > 0) {
      db.run(`UPDATE punto_entrega SET offline_uploaded_at = ? WHERE id IN (${placeholders(puntoIds.length)})`, [
        uploadedAtIso,
        ...puntoIds,
      ]);
    }
    if (redencionIds.length > 0) {
      db.run(`UPDATE redenciones_bono SET offline_uploaded_at = ? WHERE id IN (${placeholders(redencionIds.length)})`, [
        uploadedAtIso,
        ...redencionIds,
      ]);
    }
    db.run('COMMIT');
    notifyPersist();
  } catch (e) {
    rollbackQuiet(db);
    throw e;
  }
}
